import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ShipmentAdjustmentOrder } from 'projects/service/src/app/shared/models/shipment-adjustment-order.model';

@Component({
    selector: 'app-shipment-adjustment-order-popup-details-tab',
    templateUrl: './shipment-adjustment-order-popup-details-tab.component.html',
    styleUrls: ['./shipment-adjustment-order-popup-details-tab.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ShipmentAdjustmentOrderPopupDetailsTabComponent implements OnInit {

  @Input() data: ShipmentAdjustmentOrder;

  constructor() { }

  ngOnInit(): void {
  }

}
